import React from 'react';
import RadioSection from '../../Sections/RadioSection';
import SectionHeader from '../../Basic/SectionHeader';
class CreateProfileInfo extends React.Component {
  render() {
    const p = this.props;
    const lookup = window.osa.commonLookup && window.osa.commonLookup.userProfile;
    return (
      <div>
        <div className="col-sm-12" >
          <div className="form-group">
            <SectionHeader title={lookup ? lookup.userProfileInfoTitle : null} />
            <ul>
              <li type="square">{lookup ? lookup.userProfileInfo1 : null}</li>
              <li type="square">{lookup ? lookup.userProfileInfo2 : null}</li>
              <li type="square">{lookup ? lookup.userProfileInfo3 : null}</li>
              <li type="square">{lookup ? lookup.userProfileInfo4 : null}</li>
            </ul>
            <p>{lookup ? lookup.userProfileImportant : null}  <a target="_blank" href="https://accounts.fortisbc.com/">Account Online</a> profile.</p>
          </div>
          <RadioSection {...lookup.selectOption} name="createProfileSelectOption" />
        </div>
      </div>
    );
  }
}
export default CreateProfileInfo;

